/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate } from 'framework/authorization';
import { useCandidateService } from 'domain/shared/candidate';

const CandidateDuplicateScanContext = ({
  permissionToCheck,
  children,
}: {
  permissionToCheck: string | string[];
  children: React.ReactNode;
}) => {
  const { getCombinedPermissionsDuplicates } = useCandidateService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getCombinedPermissionsDuplicates}
      permissionToCheck={permissionToCheck}
      contextName="CandidateDuplicateScan"
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default CandidateDuplicateScanContext;
